import { render } from "./PrivacySection.vue?vue&type=template&id=2add2429&scoped=true"
import script from "./PrivacySection.vue?vue&type=script&lang=js"
export * from "./PrivacySection.vue?vue&type=script&lang=js"

import "./PrivacySection.vue?vue&type=style&index=0&id=2add2429&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add2429"]])

export default __exports__